export default __webpack_public_path__ + "static/media/error-order.938b89a6.svg";